export enum QuotaObjectTypes {
    Users = 1,
    Shared = 2,
    Printers = 4,
}
